export default __webpack_public_path__ + "static/media/property_587.66bc15a6.png";